import type { SkillConfig } from '@netsuite-ai/types';

interface Props {
  value: SkillConfig['identity'];
  onChange: (v: SkillConfig['identity']) => void;
}

export default function Identity({ value, onChange }: Props) {
  function set(field: keyof SkillConfig['identity'], v: string) {
    onChange({ ...value, [field]: v });
  }

  return (
    <div className="space-y-4">
      <Field label="Name">
        <input
          type="text"
          value={value.name}
          onChange={(e) => set('name', e.target.value)}
          className="w-full rounded border border-neutral-300 px-3 py-2 text-sm outline-none focus:border-neutral-500"
        />
      </Field>
      <Field label="Description">
        <input
          type="text"
          value={value.description}
          onChange={(e) => set('description', e.target.value)}
          className="w-full rounded border border-neutral-300 px-3 py-2 text-sm outline-none focus:border-neutral-500"
        />
      </Field>
      <Field label="When to use this skill">
        <textarea
          rows={3}
          value={value.whenToUse}
          onChange={(e) => set('whenToUse', e.target.value)}
          className="w-full resize-none rounded border border-neutral-300 px-3 py-2 text-sm outline-none focus:border-neutral-500"
        />
      </Field>
    </div>
  );
}

function Field({
  label,
  children,
}: {
  label: string;
  children: React.ReactNode;
}) {
  return (
    <div className="space-y-1">
      <p className="text-xs font-medium text-neutral-600">{label}</p>
      {children}
    </div>
  );
}
